import { ACTION_DATA_INTER, ACTION_TYPE, STORE_INTER } from './constant';
import { ActionData } from '../../lib/store/core';

const initialState: STORE_INTER = {
  logged: null,
  user: null,
};

export function Store(
  state = initialState,
  action: ActionData<ACTION_DATA_INTER>,
) {
  switch (action.type) {
    case ACTION_TYPE.SET_DATA:
      return {
        ...state,
        logged: !!action.data.user,
        user: action.data.user,
      };

    case ACTION_TYPE.CLEAR_DATA:
      return {
        ...initialState,
      };

    default:
      return state;
  }
}
